export default "/images/vendor/@coreui/icons/svg/flag/cif-om.svg?189bcb3ccbbd5da883534ecfdeede4e3";